import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import { getThousandComma } from "../../../../../Api/ApiCommon";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { TotalCount } from "../../../../../pages/Users/UserInfo";
import LineBtn from "../../../../Button/LineBtn";
import Blank from "../../../../DefaultStyles/Blank";
import Flex from "../../../../DefaultStyles/Flex";
import LineBox from "../../../../DefaultStyles/LineBox";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface SSelectTableRow {
  selected: boolean;
}

interface SSearchTag {
  isClickable?: boolean;
}

interface IChatMember {
  name: string;
  nickname: string;
  partyid: string;
  uid: string;
  servsubsid: number;
}

interface ChatSearchResultProps {
  dropDownValue: {
    label?: string;
    value?: string;
  };
  searchValue?: string;
  response: any;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  setChatId: Dispatch<SetStateAction<string>>;
}

export const recentChatBtnClick = atom<boolean>({
  key: "recentChatBtnClick",
  default: false,
});

export default function ChatSearchResult({
  dropDownValue,
  searchValue,
  response,
  page,
  setPage,
  setChatId,
}: ChatSearchResultProps) {
  const navigate = useNavigate();

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [btnClick, setBtnClick] = useRecoilState(recentChatBtnClick);

  const isMemberUidSearch = dropDownValue?.value === "3";

  const tableHead = [
    "NO",
    "PID",
    "Subscription",
    "(파티장)UID_이름_닉네임",
    "(파티원)UID_이름_닉네임",
    "최근 대화 조회",
  ];

  useEffect(() => {
    setTimeout(() => {
      setActiveIndex(null);
    }, 100);
  }, [page, searchValue]);

  return (
    <ChatSection>
      <ChatSectionTitle>채팅 검색 결과</ChatSectionTitle>

      <Flex>
        <SearchTag>
          {dropDownValue?.label}_{searchValue}
        </SearchTag>
      </Flex>

      <Blank blankHeight={12} />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {(isMemberUidSearch
              ? response?.data?.items[0]?.owner
              : response?.data?.items[0]?.member
            )?.map((d: IChatMember, index: number) => {
              return (
                <SelectTableRow key={index} selected={activeIndex === index}>
                  <TableBodyItem>
                    {response?.data?.totalCount - (page * 10 + index)}
                  </TableBodyItem>
                  <TableBodyItem
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      if (d?.partyid) {
                        navigate(`/party/info/${d?.partyid}`);
                      }
                    }}
                  >
                    {d?.partyid}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.servsubsid}_{getSubsNameBySubsId3(d?.servsubsid)}
                  </TableBodyItem>
                  <TableBodyItem
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      if (isMemberUidSearch) {
                        navigate(`/party/info/${d?.uid}`);
                      } else {
                        navigate(
                          `/party/info/${response?.data?.items[0]?.owner[0]?.uid}`
                        );
                      }
                    }}
                  >
                    {isMemberUidSearch
                      ? `${d?.uid}_${d?.name}_${d?.nickname}`
                      : `${response?.data?.items[0]?.owner[0]?.uid}_${response?.data?.items[0]?.owner[0]?.name}_${response?.data?.items[0]?.owner[0]?.nickname}`}
                  </TableBodyItem>
                  <TableBodyItem
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      if (isMemberUidSearch) {
                        navigate(
                          `/party/info/${response?.data?.items[0]?.member[0]?.uid}`
                        );
                      } else {
                        navigate(`/party/info/${d?.uid}`);
                      }
                    }}
                  >
                    {isMemberUidSearch
                      ? `${response?.data?.items[0]?.member[0]?.uid}_
                    ${response?.data?.items[0]?.member[0]?.name}_
                    ${response?.data?.items[0]?.member[0]?.nickname}`
                      : `${d?.uid}_${d?.name}_${d?.nickname}`}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="최근 대화 조회"
                      btnClickEvent={() => {
                        setBtnClick(true);

                        setActiveIndex(index);

                        setChatId(
                          isMemberUidSearch
                            ? `${d?.partyid}@${d?.uid}@${response?.data?.items[0]?.member[0]?.uid}`
                            : `${d?.partyid}@${response?.data?.items[0]?.owner[0]?.uid}@${d?.uid}`
                        );

                        window.scrollTo({
                          top: document?.getElementById("recent-chat-section")
                            ?.offsetTop,
                          left: 0,
                          behavior: "smooth",
                        });
                      }}
                    />
                  </TableBodyItem>
                </SelectTableRow>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 10}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
            pageSize={response?.status === 200 ? +response?.data?.pageSize : 0}
          />

          <TotalCount>
            총 {getThousandComma(+response?.data?.totalCount)}개
          </TotalCount>
        </SpaceBetween>
      </LineBox>
    </ChatSection>
  );
}

export const ChatSection = styled.section`
  width: 100%;
  margin-top: 44px;
`;

export const ChatSectionTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  color: #2f2f38;
  margin-bottom: 20px;
`;

export const SearchTag = styled.label<SSearchTag>`
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "auto")};
  padding: 10px 15px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #dfe3e9;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #606060;
  text-decoration: ${({ isClickable }) => (isClickable ? "underline" : "none")};

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const SelectTableRow = styled(TableBody)<SSelectTableRow>`
  background-color: ${({ theme, selected }) =>
    selected ? "#f5f5f5" : theme.color.white};
`;
